import React, {Component} from 'react';
import {connect} from 'react-redux';
import Settings from './components/organisms/settings';
import StackItems from './components/organisms/stack-items';

class PlayerCombinationStacking extends Component {
    render() {
        const {sportConfig, stacking} = this.props;

        if (!sportConfig.isReady()) {
            return null;
        }

        return (
            <div className={'advanced-filter advanced-open'}>
                <Settings key={stacking.getSignature()} />
                <StackItems />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playerCombinationStacking, sportConfig} = state;

    return {
        sportConfig,
        stacking: playerCombinationStacking,
    };
}

export default connect(mapStatesToProps)(PlayerCombinationStacking);
